var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin-box",
    transform: "translate(-133 -152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M42,21c0,11.6-21,33-21,33S0,32.6,0,21a21,21,0,0,1,42,0",
    transform: "translate(133 152)",
    fill: "#00f892"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_-_box",
    "data-name": "icon - box",
    transform: "translate(141 160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 26,
    height: 26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_24",
    "data-name": "Exclusion 24",
    d: "M5405.059-854h0v-8.979l10.679-2.074.045,8.991L5405.06-854Zm-1.051-.05h0l-6.96-2.089v-9.014l6.961,2.128v8.973Zm.553-9.9h0l-5.873-1.8,9.49-1.843.084,0,5.9,1.771-9.6,1.865Zm5.2-2.83a.534.534,0,0,0-.1.009l-5.858,1.136a.521.521,0,0,0-.335.222.522.522,0,0,0-.08.393.524.524,0,0,0,.514.425.491.491,0,0,0,.1-.01l5.858-1.138a.525.525,0,0,0,.415-.616A.523.523,0,0,0,5409.76-866.783Zm-12.716.149h0l-.043-7.212L5407.723-876v7.293l-10.678,2.073Z",
    transform: "translate(-5392 878)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBox);
export default __webpack_public_path__ + "static/media/pin-box.a695b5bf4add7e0572802d87333c6674.svg";
export { ForwardRef as ReactComponent };